import "./WhatsNewModal.scss";
import React, { useState } from "react";
import { Grid, IconButton } from "@material-ui/core";
import { RhimDialog } from "@rhim/rhim-ui";
import { useTranslation } from "react-i18next";
import { useStoreState, useStoreActions } from "../../../store/hooks";
import WhatsNewItem from "./WhatsNewItem";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() =>
  createStyles({
    modalTitle: {
      fontFamily: "Neutrif Pro Bold",
      fontSize: 18,
      color: "#0a3566",
      margin: 0,
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      width: "100%"
    },
    closeButton: {
      position: "absolute",
      right: 0,
      top: 0,
      color: "#0a3566",
      padding: 0
    },
    content: {
      padding: "16px 8px 0 8px",
      overflow: "hidden",
      maxWidth: 500,
      margin: "0 auto"
    },
    closeButtonText: {
      color: "white",
      fontFamily: "Neutrif Pro",
      fontSize: 16,
      width: "100%",
      backgroundColor: "#0a3566",
      borderRadius: 4,
      padding: "12px 16px",
      cursor: "pointer",
      border: "none",
      marginTop: 16
    }
  })
);

const WhatsNewModal: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const items = useStoreState((state) => state.whatsNew.items);
  const visible = useStoreState((state) => state.whatsNew.visible);
  const setVisible = useStoreActions((actions) => actions.whatsNew.setVisible);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClose = () => {
    setVisible(false);
  };

  const renderTitle = () => {
    return (
      <div className={classes.modalTitle}>
        {t("whatsNew.title", "What's new")}
        <IconButton className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={classes.content}>
        <Grid container spacing={0}>
          <WhatsNewItem 
            key={currentIndex} 
            item={items[currentIndex]} 
          />
        </Grid>
        <button className={classes.closeButtonText} onClick={handleClose}>
          {t("common.close", "Close")}
        </button>
      </div>
    );
  };

  return (
    <RhimDialog
      isMobile={false}
      title={renderTitle()}
      isOpen={visible}
      content={renderContent()}
    />
  );
};

export default WhatsNewModal; 